import React from 'react';
import PropTypes from 'prop-types';
// 1. Swap Polyglot HOC for modern i18next hook
import { useTranslation } from 'react-i18next';

import MoodDepressedIcon from '../../assets/icons/mood-depressed.svg';
import MoodSadIcon from '../../assets/icons/mood-sad.svg';
import MoodOkayIcon from '../../assets/icons/mood-okay.svg';
import MoodHappyIcon from '../../assets/icons/mood-happy.svg';

import { 
  FormCheckbox,
  FormLabel,
  FormTextArea,
  FormRadio,
  BaseForm
} from '../form';
import IconChooser from '../form/FormIconChooser';
import HelpTooltip from '../edu/HelpTooltip';
import { Button } from '../buttons';

import './DiaryEntryForm.scss';

const DiaryEntryForm = ({ 
  isNew = true, 
  onSubmit = () => {}, 
  initialValues = {} 
}) => {
  // 2. Initialize the translation hook
  const { t } = useTranslation();

  const feelings = [
    { name: 'feeling', value: 'depressed', icon: MoodDepressedIcon },
    { name: 'feeling', value: 'sad', icon: MoodSadIcon },
    { name: 'feeling', value: 'okay', icon: MoodOkayIcon },
    { name: 'feeling', value: 'happy', icon: MoodHappyIcon }
  ];

  return (
    <BaseForm onSubmit={onSubmit} className="diary-entry-form">
      <h2>
        {isNew ? t('diaryEditor.createTitle') : t('diaryEditor.editTitle')}
      </h2>

      <FormLabel center>{t('diaryEditor.feelingLabel')}</FormLabel>
      
      <IconChooser className="icon-chooser--small diary-entry-form__feeling-chooser">
        {feelings.map((feeling) => (
          <FormRadio
            key={feeling.value}
            name={feeling.name}
            // Default to 'happy' for new entries, or use the stored feeling for edits
            initialValue={isNew ? 'happy' : initialValues.feeling}
            value={feeling.value}
            imageSrc={feeling.icon}
            imageAlt={t(`diary.${feeling.value}`)}
            className={`diary-entry-form__feeling--${feeling.value}`}
          />
        ))}
      </IconChooser>

      <FormTextArea
        labelRenderer={() => (
          <FormLabel note={t('diaryEditor.optional')}>
            {t('diaryEditor.contentLabel')}
          </FormLabel>
        )}
        initialValue={isNew ? '' : initialValues.content}
        name="content"
        className="diary-entry-form__textarea"
      />

      <div className="form-footer-columns">
        <div className="form-footer-columns__left">
          <FormCheckbox 
            name="hidden"
            initialValue={isNew ? true : initialValues.hidden}
          >
            {t('diaryEditor.hiddenLabel')}
          </FormCheckbox>
          <HelpTooltip html={t('diaryEditor.hiddenNote')} />
        </div>

        <div className="form-footer-columns__right">
          <Button label={t('diaryEditor.save')} />
        </div>
      </div>
    </BaseForm>
  );
};

// 3. PropTypes updated (t removed)
DiaryEntryForm.propTypes = {
  isNew: PropTypes.bool,
  onSubmit: PropTypes.func,
  initialValues: PropTypes.shape({
    feeling: PropTypes.string,
    content: PropTypes.string,
    hidden: PropTypes.bool
  })
};

export default DiaryEntryForm;
